import React, { useEffect } from "react";

import { useTranslation } from "react-i18next";

import DesktopLayout from "@components-shared/desktop/layout/DesktopLayout";
import { HeaderType } from "@data-types/layout/headerTypeEnum";
import { redirectUserToHomePageAfterRegistration } from "@utils";

import { OnBoardingFooter, OnBoardingSlider } from "../shared";

export default function RegistrationSuccess() {
	const { t } = useTranslation("registration");

	const redirectToHomePage = () => {
		redirectUserToHomePageAfterRegistration();
	};

	useEffect(() => {
		document.querySelector("html, body")?.scrollTo(0, 0);
	}, []);

	return (
		<DesktopLayout
			headerType={HeaderType.EMPTY}
			mainClassName="at-RegistrationSuccess l--main l--main--grow"
		>
			<section className="l--content l--content--full">
				<div className="l--content__main u-padd--reset">
					<div className="container container--med container--grow">
						<div className="card--onboarding card--onboarding--grow card--shadowy">
							<OnBoardingSlider />
							<div className="card--onboarding__form card--onboarding__form--center">
								<div className="card--onboarding__header card--onboarding__header--vertical">
									<i className="u-icon u-icon--xxxlrg u-icon--check-circle u-icon--animated--bounce-in u-color--sent--success" />
									<div className="u-mar--top--med u-type--xlrg u-type--wgt--medium u-type--center">
										{t(
											"REGISTRATION_SUCCESS.CONGRATULATIONS"
										)}
									</div>
								</div>

								<div className="card--onboarding__content card--onboarding__content--shrink">
									<div className="u-mar--bottom--big">
										<div className="u-mar--bottom--xsml">
											{t(
												"REGISTRATION_SUCCESS.SUCCESSFULY_CREATED"
											)}
										</div>
										<div>
											{t(
												"REGISTRATION_SUCCESS.REGISTRATION_NOTE"
											)}
										</div>
									</div>

									<div className="u-mar--bottom--big">
										<div className="u-mar--bottom--xtny u-type--base u-type--wgt--medium">
											{t(
												"REGISTRATION_SUCCESS.PLAY_RESPONSIBLY"
											)}
										</div>
										<div>
											{t(
												"specific:MEMBERSHIP.RESPONSIBLE_GAMING.MESSAGE"
											)}
										</div>
									</div>

									<div>
										{t(
											"REGISTRATION_SUCCESS.WISHES_MESSAGE"
										)}
									</div>
								</div>

								<button
									className="btn btn--base btn--block btn--accent"
									onClick={redirectToHomePage}
								>
									{t("COMMON.BACK_TO_HOME_PAGE")}
								</button>
							</div>
						</div>

						<OnBoardingFooter />
					</div>
				</div>
			</section>
		</DesktopLayout>
	);
}
